var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-template-tab',{attrs:{"title":"Increase Conversion"}},[_c('p',[_vm._v("This is one the best ways to increase your conversion buddy!")])])}
var staticRenderFns = []

export { render, staticRenderFns }